import baseinfoRouter from "./baseinfo/index"
import memberRouter from "./member/index"
import groupRouter from "./group/index"
import route from "@/components/router/Router"
import tag from "./tag/index"
import card from "./card/index"
import itemManage from "./itemManage/index"
import carryManage from "./carryManage/index"
import fileConfig from "./fileConfig/index"
import administrativeArea from "./administrativeArea/index"
import belongArea from "./belongArea/index"
import itemOrigin from "./itemOrigin/index"
import professionCategory from "./professionCategory/index"
import companyArea from "./companyArea/index"

export default {
    path : "company",
    name : "company",
    meta : {
        title : "单位",
    },
    redirect : {
        name : "companyinfo",
    },
    component: route,
    children : [
        baseinfoRouter,
        ...memberRouter,
        ...groupRouter,
        ...tag,
        ...card,
        itemManage,
        carryManage,
        fileConfig,
        administrativeArea,
        belongArea,
        itemOrigin,
        professionCategory,
        companyArea
    ],
}


// WEBPACK FOOTER //
// ./src/router/company/indexRouter.js